import MembershipOrdersListRow from './MembershipOrdersListRow';

import './MembershipOrdersList.scss';

const MembershipOrdersList = ({ listData }) => (
  <div className="MembershipOrdersList">
    {listData.map((rowData) => (
      <MembershipOrdersListRow rowData={rowData} key={rowData.uid} />
    ))}
  </div>
);

export default MembershipOrdersList;
